import { DebugService } from '../shared/services/debug.service.js';

class _PerformanceTrackingService {
  constructor() {
    this.debug = new DebugService('PerformanceTrackingService');
    this._alreadyTracked = [];
  }

  performanceTrackStart(name) {
    if (!this._alreadyTracked.find((value) => value === name)) {
      this.debug.log(`${name} Load Start - QMPM`, Date.now());
      window.performance.mark(`${name} - start`);
    }
  }

  performanceTrackStop(name) {
    if (!this._alreadyTracked.find((value) => value === name)) {
      this.debug.log(`${name} Load Done - QMPM`, Date.now());
      window.performance.mark(`${name} - stop`);
      this._alreadyTracked.push(name);
    }
  }
}
export const PerformanceTrackingService = new _PerformanceTrackingService();
